<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <el-table
        :data="tableData"
        style="width: 100%"
        height="600"
        :header-cell-style="{
          background: '#e3eef6',
          color: '#048bef'
        }"
      >
        <el-table-column prop="date" label="板块" min-width="380">
          <template slot-scope="scope">
            <div
              style="margin-left: 10px"
              class="plate-title"
              @click="plateTitleHandle(scope.row)"
            >
              {{ scope.row.columnName }}
              <span style="color: #FF142F;font-weight: 550; font-size: 16px;">
                (今日 {{ scope.row.todayThemeCount }})</span
              >
            </div>
            <div style="margin-left: 10px; margin-top: 8px; font-size: 13px;">
              {{ scope.row.introductory }}
            </div>
            <div
              style="margin-left: 10px; color: #999999; margin-top: 8px;font-size: 13px;"
            >
              管理员：
              <span
                v-for="(item, index) in scope.row.administratorNames"
                :key="index"
              >
                {{ item.userName }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="themeCount" label="帖子/回复" min-width="180">
          <template slot-scope="scope">
            <div style="margin-left: 10px; font-size: 13px;">
              <span style="color:#0089EF">{{ scope.row.themeCount }}</span
              >/{{ scope.row.replyCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="themeName" label="最后发表" min-width="200">
          <template slot-scope="scope">
            <div
              style="margin-left: 10px;font-size: 13px;"
              class="theme-title"
              @click="themeTitle(scope.row)"
            >
              {{ scope.row.lastTheme ? scope.row.lastTheme.themeName : "" }}
            </div>
            <div style="margin-left: 10px;font-size: 13px;">
              {{ scope.row.lastTheme ? scope.row.lastTheme.createTime : "" }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="ccui-table-footer">
        <div id="ccui-paging">
          <el-pagination
            :total="pageTotal"
            :page-size="pageSize"
            :current-page="pageNo"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange('none')"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import { qryGateWayForumPage, addViewCount } from "@/app/shop/api/shopping";
import Cookies from "js-cookie";
export default {
  name: "exchangeForum",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  props: {
    currBreadCrumb: {
      type: Array,
      default: () => {
        return [];
      }
    },
    source: {
      type: String,
      default: ""
    },
    activeIndex: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [],
      pageTotal: 0,
      pageSize: 10,
      pageNo: 0,
      isLogin: false
    };
  },
  activated() {
    console.log(this.currBreadCrumb, "currBreadCrumb");
    this.getList();
    if (Cookies.get("access_token")) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  },
  deactivated() {
    this.initData();
  },
  methods: {
    getList(val) {
      qryGateWayForumPage({
        pageNo: val || 1,
        pageSize: 10,
        isShowLoading: true
      }).then(res => {
        if (res.data.code == "0") {
          //   console.log(res.data.data)
          this.tableData = res.data.data.rows;
          this.pageNo = res.data.data.pageNo;
          this.pageTotal = res.data.data.recordsTotal;
          console.log(this.tableData, "tableData");
        }
      });
    },
    plateTitleHandle(row) {
      // this.$router.push({name:"plateTitle"})
      if (!this.isLogin) {
        this.$message({
          showClose: true,
          message: "当前用户未登录，请先登录！",
          type: "error"
        });
        return false;
      }
      let administratorNamesStr = "";
      row.administratorNames.forEach(item => {
        administratorNamesStr += item.userName + " ";
      });
      this.$router.push({
        path: "/plateTitle",
        // name: "plateTitle",
        query: {
          businessId: row.columnId, // this.$route.query
          introductory: row.introductory,
          themeCount: row.themeCount,
          replyCount: row.replyCount,
          columnName: row.columnName,
          administratorNamesStr,
          activeIndex: this.$route.query.activeIndex
        }
        // params: {
        //   businessId: row.columnId,
        //   row: row
        // }
      });
    },
    themeTitle(row) {
      if (!this.isLogin) {
        this.$message({
          showClose: true,
          message: "当前用户未登录，请先登录！",
          type: "error"
        });
        return false;
      }
      let params = {
        businessId: row.lastTheme.themeId,
        isShowLoading: true
      };
      addViewCount(params).then(res => {
        if (res.data.code == "0") {
          this.$router.push({
            path: "/themeDetails",
            query: {
              themeId: row.lastTheme.themeId,
              activeIndex: this.$route.query.activeIndex
            }
          });
        }
      });
    },
    handlePrev() {
      //   --this.pageNo;
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleNext() {
      //   ++this.pageNo;
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleSizeChange(val) {
      //   this.pageNo = 1;
      //   if (val !== "none") {
      //     this.pageSize = val;
      //     // setSessionItem("pageSize", this.tableName, val);
      //   }
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleCurrentChange(val) {
      this.getList(val);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-table td {
  padding: 12px 40px !important;
}
::v-deep .el-table th {
  padding-left: 50px !important;
}
::v-deep .el-table__header {
  background: rgb(227, 238, 246);
}

/* 为Element UI的Table组件修改滚动条颜色 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px; /* 设置滚动条宽度 */
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #ffffff; /* 滚动条轨道颜色 */
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #9e9e9e; /* 滚动条手柄颜色 */
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #5f5f5f; /* 滚动条手柄hover颜色 */
}
.ccui-app-container {
  min-height: 700px;
  padding: 0px !important;
}
.wrapper {
  position: relative;
  .ccui-table-footer {
    // position: absolute;
    // left: 60%;
    // bottom: 40px;
    text-align: right;
    margin-top: 30px;
    margin-right: 17px;
  }
}
.plate-title {
  cursor: pointer;
}
.plate-title:hover {
  color: #0089ef;
}
.theme-title {
  cursor: pointer;
}
.theme-title:hover {
  color: #0089ef;
}
</style>
